export default "__VITE_ASSET__D1siAX2N__"